import axios from "axios";

export default function SystemStatus({ status, API, onRefresh }) {
  const changeMode = async (mode) => {
    await axios.post(`${API}/mode/${mode}`);
    onRefresh();
  };

  const toggleKillSwitch = async () => {
    const state = status?.kill_switch ? "off" : "on";
    await axios.post(`${API}/kill-switch/${state}`);
    onRefresh();
  };

  return (
    <div style={card}>
      <h2 style={heading}>System Status</h2>

      <div style={row}>
        <span style={label}>Status</span>
        <span style={{ ...value, color: "#1D9E75" }}>
          {status?.status?.toUpperCase() || "..."}
        </span>
      </div>
      <div style={row}>
        <span style={label}>Mode</span>
        <span style={value}>{status?.mode || "..."}</span>
      </div>
      <div style={row}>
        <span style={label}>Open Positions</span>
        <span style={value}>{status?.open_positions ?? "..."}</span>
      </div>
      <div style={row}>
        <span style={label}>Pending Approvals</span>
        <span style={value}>{status?.pending_approvals ?? "..."}</span>
      </div>
      <div style={row}>
        <span style={label}>Last Updated</span>
        <span style={{ ...value, fontSize: "11px" }}>
          {status?.time ? new Date(status.time).toLocaleTimeString() : "..."}
        </span>
      </div>

      <div style={{ marginTop: "16px" }}>
        <p style={label}>Switch Mode</p>
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {["paper_auto", "paper_manual", "live_manual"].map(m => (
            <button
              key={m}
              onClick={() => changeMode(m)}
              style={{
                ...btn,
                background: status?.mode === m ? "#1D9E75" : "#2a2a2a"
              }}
            >
              {m.replace("_", " ")}
            </button>
          ))}
        </div>
      </div>

      <button
        onClick={toggleKillSwitch}
        style={{
          ...btn,
          marginTop: "12px",
          width: "100%",
          background: status?.kill_switch ? "#1D9E75" : "#e24b4a",
          fontWeight: "700",
          fontSize: "13px"
        }}
      >
        {status?.kill_switch ? "DEACTIVATE KILL SWITCH" : "ACTIVATE KILL SWITCH"}
      </button>
    </div>
  );
}

const card = {
  background: "#1a1a1a",
  borderRadius: "12px",
  padding: "20px",
  border: "1px solid #2a2a2a"
};
const heading = {
  margin: "0 0 16px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#ffffff",
  textTransform: "uppercase",
  letterSpacing: "0.5px"
};
const row = {
  display: "flex",
  justifyContent: "space-between",
  padding: "8px 0",
  borderBottom: "1px solid #2a2a2a"
};
const label = {
  fontSize: "12px",
  color: "#888",
  margin: 0
};
const value = {
  fontSize: "13px",
  color: "#e0e0e0",
  fontWeight: "500"
};
const btn = {
  padding: "8px 12px",
  borderRadius: "8px",
  border: "none",
  color: "#fff",
  fontSize: "12px",
  cursor: "pointer"
};